import SimpleCatalog from './simple-catalog';
import TypedCatalog from './typed-catalog';

import { ComponentInfo } from '.';

const _catalog = Symbol('catalog');
const _cache = Symbol('cache');

class Catalog {

  static [_catalog] = new TypedCatalog();
  static [_cache] = new SimpleCatalog('');

  /**
   * Register the component in the catalog of components.
   *
   * @param {string} name component name.
   * @param {ComponentInfo} info component info.
   */
  static register(name: string, info: ComponentInfo): void {
    info.validate();

    const type = info.getType();

    this[_catalog]
      .get(type)
      .set(name, info);

    this[_cache].set(name, info);
  }

  /**
   * Retrieve the component info.
   *
   * @param {string} name component name.
   * @returns {ComponentInfo}.
   */
  static get(name: string): ComponentInfo {
    return this[_cache].get(name);
  }

  /**
   * Retrieve all component's name of a specific type.
   * @param {ComponentType} type desired type.
   * @returns {Array<string>}.
   */
  static listByType(type: string): string[] {
    if (this[_catalog].has(type)) {
      const keys = this[_catalog].get(type).keys();
      return Array.from(keys);
    }
    return [];
  }

}

export default Catalog;
